import { CREAM } from "../styles/theme";

/** Eager, data-free shell: visible while the Workbench route downloads. */
export function WorkbenchLoadingScreen() {
  return (
    <div
      className="flex h-full min-h-0 w-full flex-col lg:h-screen"
      style={{ background: CREAM.bg, color: CREAM.ink, fontFamily: CREAM.font }}
      role="status"
      aria-label="Opening workbench"
    >
      <div className="flex h-12 shrink-0 items-center border-b px-4" style={{ borderColor: CREAM.borderStrong }}>
        <span className="text-sm font-medium">Opening workbench…</span>
      </div>
      <div className="flex h-11 shrink-0 items-center px-4" aria-hidden="true">
        <div className="h-3 w-1/2 max-w-md rounded motion-safe:animate-pulse" style={{ background: CREAM.hoverStrong }} />
      </div>
      <div className="flex min-h-0 flex-1 gap-2 p-2" aria-hidden="true">
        <div className="flex min-w-0 flex-1 flex-col gap-2">
          <div className="flex flex-1 items-center justify-center rounded-lg border" style={{ background: CREAM.card, borderColor: CREAM.borderStrong }}>
            <span className="text-sm" style={{ color: CREAM.mute }}>Preparing playback…</span>
          </div>
          <div className="h-16 shrink-0 rounded-lg" style={{ background: CREAM.panel }} />
        </div>
        <div className="hidden w-[440px] max-w-[40%] shrink-0 flex-col gap-3 rounded-lg p-4 sm:flex" style={{ background: CREAM.panel }}>
          {["Queries", "Events", "Videos"].map((label) => (
            <div key={label} className="flex flex-1 flex-col gap-3">
              <span className="text-xs font-medium">{label}</span>
              <div className="h-3 w-4/5 rounded motion-safe:animate-pulse" style={{ background: CREAM.hoverStrong }} />
              <div className="h-3 w-3/5 rounded motion-safe:animate-pulse" style={{ background: CREAM.hover }} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
